
import React from 'react';
import LoginPageMobile from '../components/LoginPageMobile';
import IDLogin from '../components/IDLogin';
import UserLogin from '../components/UserLogin';
import { useLogin } from '../hooks/useLogin';
import { Body } from '../components/layout/Body';
import {Page} from '../components/ui/Page';

interface LoginPageProps {
	id?: string;
}
// ...existing code...

//============================================================================= LoginPage
export default function LoginPage(props: Readonly<LoginPageProps>) {
	const login = useLogin();
	return (
		<div className='self-center'>
		<Page id="login" className="content-center">
			<img
				className="drone-image-background"
				src="/assets/homepage-group.svg"
				alt=""
			/>
			<div className="login-mobile-container md:hidden mx-6 relative">
				<h1 className='home-page-header text-center mb-10 mt-16 md:mt-0'>Willkommen bei Digital Sky</h1>
				<LoginPageMobile {...login} />
			</div>
			<div style={{ display: 'none' }} className="md:!block">
				<Body id={props.id}>
					<h1 className='home-page-header'>Willkommen bei Digital Sky</h1>
					<div className="flex flex-row w-full gap-8 items-stretch">

						<div className="w-1/2 flex flex-col">
							<h2 className="mb-4 subtitle-homepage">Anmeldung mit ID-Austria</h2>
							<IDLogin onLoginIdAustria={login.onLoginIdAustria} />

						</div>
						<div className="w-1/2 flex flex-col">
							<h2 className="mb-4 subtitle-homepage">Anmeldung mit Benutzername</h2>
							<UserLogin
								loginData={login.loginData}
								valid={login.valid}
								loginError={login.loginError}
								onLogin={login.onLogin}
								onInputChange={login.handleInputChange}
								onCheckboxChange={login.handleCheckboxChange}
							/>
						</div>
					</div>
				</Body>
			</div>
		</Page>
		</div>
	);
}
